module.exports = __webpack_public_path__ + "img/ctasingle.2e650571.jpeg";